import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { getBaseUrl } from "../../service/apiUrl";
export const STATUSES = Object.freeze({
    IDLE: 'idle',
    ERROR: 'error',
    LOADING: 'loading',
});


const getTrainerRecordSlice = createSlice({
    name: 'trainerrecord',
    initialState: {
        data: [],
        statusdata: STATUSES.IDLE,
    },

    extraReducers: (builder) => {
        builder
            .addCase(fetchTrainerRecord.pending, (state, action) => {
                state.statusdata = STATUSES.LOADING;
            })
            .addCase(fetchTrainerRecord.fulfilled, (state, action) => {
                state.data = action.payload;
                state.statusdata = STATUSES.IDLE
            })
            .addCase(fetchTrainerRecord.rejected, (state, action) => {
                state.statusdata = STATUSES.ERROR;
            })
    }
});



export const { setTrainer, setStatus } = getTrainerRecordSlice.actions;
export default getTrainerRecordSlice.reducer;

export const fetchTrainerRecord = createAsyncThunk('/TrainerHistory/fetch', async ({ 
    id ,
    StartDate,
    EndDate,
    Nationality,
    RaceCourse,
    GroundType,
    RaceKind,
    HorseKind,
    RaceType,
    TrackLength}) => {
    const finalId = id?._id || id;
    const res = await axios.get(`${getBaseUrl()}/TrainerHistoryV3/${finalId}?StartDate=${StartDate === undefined ? "" : StartDate}&EndDate=${EndDate === undefined ? "" : EndDate}&Nationality=${Nationality === undefined ? "" : Nationality}&RaceCourse=${RaceCourse === undefined ? "" : RaceCourse}&GroundType=${GroundType === undefined ? "" : GroundType}&RaceKind=${RaceKind === undefined ? "" : RaceKind}&HorseKind=${HorseKind === undefined ? "" : HorseKind }&RaceType=${RaceType=== undefined ? "" : RaceType}&TrackLength=${TrackLength === undefined ? "" : TrackLength}`);
    const trainerstatsData = res.data;
    return trainerstatsData.data;
})